import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PSelect,
  PSelectOption,
  PSelectProps,
} from '@porsche-design-system/components-react';

type ColorPaletteSelectOption = PSelectProps & {
  colorPalettes: Record<string, string[]>;
  getPaletteLabel: (key: string) => string;
};

const ColorPaletteOption = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '6.25rem 1fr',
    gridGap: '0.9375rem',
  },
});

export const ColorPaletteSelect = ({
  colorPalettes,
  ...props
}: ColorPaletteSelectOption) => {
  const palettes = Object.keys(colorPalettes);
  const options = palettes.map((paletteKey) => {
    const labelName = props.getPaletteLabel(paletteKey);
    return {
      label: (
        <ColorPaletteOption
          aria-label={`Palette ${labelName}`}
          aria-selected={paletteKey === props.value}
        >
          <ColorSwatch colors={colorPalettes[paletteKey]} />
          {labelName}
        </ColorPaletteOption>
      ),
      value: paletteKey,
    };
  });
  const selectedOption = options.find(({ value }) => value === props.value);
  return (
    <PSelect {...props} value={selectedOption?.value} filter={false}>
      {options.map(({ label, value }) => (
        <PSelectOption key={value} value={value}>
          {label}
        </PSelectOption>
      ))}
    </PSelect>
  );
};

const ColorSwatch = ({ colors }: { colors: string[] }) => {
  const background = `linear-gradient(to right, ${colors
    .map(
      (c, i) =>
        `${c} ${(i / colors.length) * 100}%, ${c} ${
          ((i + 1) / colors.length) * 100
        }%`,
    )
    .join(', ')})`;

  return <div style={{ background }} />;
};
